"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const cap_react_widget_1 = require("@pitininja/cap-react-widget");
const react_i18next_1 = require("react-i18next");
const ENDPOINT = '/captcha/';
// FIXME The widget loads a file from cdn.jsdelivr.net, which is not ideal for
// production. We should consider hosting the wasm library ourselves.
const CapJsCaptcha = ({ onCaptchaValid, reloadKey }) => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const widgetRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        var _a;
        // Reset the widget if the reloadKey changes
        // FIXME The 'reset' event is not in the type definitions and causes a TS error. Version 1.1.1 of the library did not require this cast. See if it is fixed again in later versions.
        (_a = widgetRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent('reset');
    }, [reloadKey]);
    return (react_1.default.createElement(cap_react_widget_1.CapWidget, { ref: widgetRef, endpoint: ENDPOINT, onSolve: (token) => {
            onCaptchaValid(true, token);
        }, onError: () => {
            onCaptchaValid(false);
        }, i18nError: t('auth:CapJScaptcha:errorLabel'), i18nInitial: t('auth:CapJScaptcha:initialLabel'), i18nSolved: t('auth:CapJScaptcha:solvedLabel'), i18nVerifying: t('auth:CapJScaptcha:verifyingLabel') }));
};
exports.default = CapJsCaptcha;
//# sourceMappingURL=CapJsCaptcha.js.map